module.exports = {
	config: {
		usage: 'management' // NOTE: 	"management" is used by default (address management)
							// 			"selection" is used to select an address (e.g., for address connections) instead of editing one.
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'showInsert') {
							self.model.entityTable.showInsert()
						} else if(fieldType === 'showEdit'){
							self.showEdit()
						} else if(fieldType === 'logout'){
							self.logout()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						}
					}
				}
			}
		}
	},

	methods: {
		showEdit(){
			const memberID = (((((window.storage || {}).user || {}).data || {}).userTableAssociates || {}).livecom_members || {}).memberID || false

			if(!memberID){
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:members.missingMemberID'
						}
					}, {
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				)
			}

			const baseActionKey = 'showEdit_member'
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey, undefined, {
					memberProperties: {
						resourceID: memberID,
					},
				}),
				true
			)
		},

		logout(){
			return this.performAction(this.prepareAction('logout', undefined, undefined, {
				postProcessing: [
					{ destroyLocalStore: true },
					{ forward: window.location.href || '/' }
				]
			}))
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		async onDecision($element, options){
			if(!options.decisionComponent.hasClass('base_modal_modal')){
				return
			}

			const modal = options.decisionComponent
			if(options.decisionType === 'cancel') {
				return modal.hide()
			}

			let form
			if(options.decisionComponent.hasClass('container_templates_members_propertiesForm')){
				options.decisionComponent.find('templates_members_propertiesForm', c => form = c)
			}
			if(form){
				await form.submit()
			}

			await modal.hide()
		},
	},
}